import { call, put, all, takeEvery } from 'redux-saga/effects';
import { meetingActions, generalActions } from '../actions';
import api from '../services/meeting.service';
import ACTIONS from '../constants';
import moment from 'moment';

function* fetchMeeting(state) {
  try {
    yield put(meetingActions.fetchMeetingAttempt.pending);
    const response = yield call(api.fetchMettingRequest, state.payload); 
    yield put(meetingActions.fetchMeetingAttempt.success(response));
  } catch (error) {
    yield put(meetingActions.fetchMeetingAttempt.error(error.message));
  }
}

function* createMeeting(state) {
  try {
    yield put(meetingActions.createMeetingAttempt.pending);
    yield call(api.createMettingRequest, state.payload); 
    const response = yield call(api.getMettingsRequest, `StartDate=${state.payload.dates.startDate}&EndDate=${state.payload.dates.endDate}`); 
    yield put(meetingActions.createMeetingAttempt.success(response));
    yield put(
      generalActions.showToast({  
        title: 'Meeting saved',
        type: 'success',
      }),
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if(errorObject.status === 500 || errorObject.status === 502 || errorObject === 'Network Error!') {
      yield put(meetingActions.createMeetingAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: 'Something went wrong. Please try again later.',
          type: 'error',
        }),
      );
    }
    if(errorObject.status === 422) {
      yield put(meetingActions.createMeetingAttempt.error(error.message));
    }
    if(errorObject.status === 400) {
      yield put(meetingActions.createMeetingAttempt.error(error.message));
      yield put(
        generalActions.showToast({  
          title: errorObject.data.errors[0].message,
          type: 'error',
        }),
      );
    }
  }
}

function* updateMeeting(state) {
  try {
    yield put(meetingActions.updateMeetingAttempt.pending);
    yield call(api.updateMettingRequest, state.payload); 
    const response = yield call(api.getMettingsRequest, `StartDate=${state.payload.dates.startDate}&EndDate=${state.payload.dates.endDate}`); 
    yield put(meetingActions.updateMeetingAttempt.success(response));
    yield put(
      generalActions.showToast({  
        title: 'Meeting updated successfully',
        type: 'success',
      }),
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
      if(errorObject.status === 500 || errorObject.status === 502 || errorObject === 'Network Error!') {
        yield put(meetingActions.updateMeetingAttempt.error(error.message));
        yield put(
          generalActions.showToast({
            title: 'Something went wrong. Please try again later.',
            type: 'error',
          }),
        );
      }
      if(errorObject.status === 422) {
        yield put(meetingActions.updateMeetingAttempt.error(error.message));
      }
      if(errorObject.status === 400) {
        yield put(meetingActions.updateMeetingAttempt.error(error.message));
        yield put(
          generalActions.showToast({  
            title: errorObject.data.errors[0].message,
            type: 'error',
          }),
        );
      }
  }
}

function* getMeetings(state) {
  try {
    yield put(meetingActions.getMeetingsAttempt.pending);
    const response = yield call(api.getMettingsRequest, state.payload); 
    yield put(meetingActions.getMeetingsAttempt.success(response));
  } catch (error) {
    yield put(meetingActions.getMeetingsAttempt.error(error.message));
  }
}

function* cancelMeeting(state) {
  try {
    yield put(meetingActions.cancelMeetingAttempt.pending);
    const cancelMeeting = yield call(api.cancelMettingRequest, state.payload.id, state.payload.editType, state.payload.isOccurrence);
    if(cancelMeeting.status === 400) {
      yield put(meetingActions.cancelMeetingAttempt.error(cancelMeeting.data.errors[0].message));
      yield put(
        generalActions.showToast({
          title: cancelMeeting.data.errors[0].message,
          type: "error",
        })
      );
      return;
    }
    
    const response = yield call(api.getMettingsRequest, `StartDate=${state.payload.dates.startDate}&EndDate=${state.payload.dates.endDate}`); 
    
    yield put(meetingActions.cancelMeetingAttempt.success(response));
    yield put(
      generalActions.showToast({
        title: "Meeting cancelled",
        type: "success",
      })
    );
  } catch (error) {
    yield put(meetingActions.cancelMeetingAttempt.error(error.message));
  }
}

function* deleteMeeting(state) {
  try {
    yield put(meetingActions.deleteMeetingAttempt.pending);
    yield call(api.deleteMettingRequest, state.payload.id, state.payload.editType, state.payload.isOccurrence); 
    const response = yield call(api.getMettingsRequest, `StartDate=${state.payload.dates.startDate}&EndDate=${state.payload.dates.endDate}`); 
    yield put(meetingActions.deleteMeetingAttempt.success(response));
    yield put(
      generalActions.showToast({
        title: "Meeting deleted",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if(errorObject.status === 500 || errorObject.status === 502 || errorObject === 'Network Error!') {
      yield put(meetingActions.deleteMeetingAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: 'Something went wrong. Please try again later.',
          type: 'error',
        }),
      );
    }
    if(errorObject.status === 422) {
      yield put(meetingActions.deleteMeetingAttempt.error(error.message));
    }
    if(errorObject.status === 400) {
      yield put(meetingActions.deleteMeetingAttempt.error(error.message));
      yield put(
        generalActions.showToast({  
          title: errorObject.data.errors[0].message,
          type: 'error',
        }),
      );
    }
  }
}

function* meetingRegistery(state) {
  try {
    yield put(meetingActions.getMettingsRegisteryAttempt.pending);
    const response = yield call(api.mettingRegisteryRequest, state.payload); 
    yield put(meetingActions.getMettingsRegisteryAttempt.success(response));
  } catch (error) {
    yield put(meetingActions.getMettingsRegisteryAttempt.error(error.message));
  }
}

function* sortMeetingRegistery(state) {
  try {
    yield put(meetingActions.sortRegisteryRequestAttempt.pending);
    const response = yield call(api.sortMettingRegisteryRequest, state.payload); 
    yield put(meetingActions.sortRegisteryRequestAttempt.success(response));
  } catch (error) {
    yield put(meetingActions.sortRegisteryRequestAttempt.error(error.message));
  }
}

function* meetingRegisteryPdf(state) {
  try {
    yield put(meetingActions.meetingRegistoryRequestAttempt.pending);
    const res = yield call(api.meetingRegistoryPdfRequest, state.payload.id, state.payload.isOccurrence, state.payload.dates);
    yield put(meetingActions.meetingRegistoryRequestAttempt.success(res));
  } catch (error) {
    yield put(meetingActions.meetingRegistoryRequestAttempt.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.FETCH_MEETING_CALL, fetchMeeting),
    takeEvery(ACTIONS.CREATE_MEETING_CALL, createMeeting),
    takeEvery(ACTIONS.UPDATE_MEETING_CALL, updateMeeting),
    takeEvery(ACTIONS.MEETINGS_CALL, getMeetings),
    takeEvery(ACTIONS.CANCEL_MEETING_CALL, cancelMeeting),
    takeEvery(ACTIONS.DELETE_MEETING_CALL, deleteMeeting),
    takeEvery(ACTIONS.MEETING_REGISTERY_CALL, meetingRegistery),
    takeEvery(ACTIONS.SORT_MEETING_REGISTERY_CALL, sortMeetingRegistery),
    takeEvery(ACTIONS.MEETING_REGISTERY_PDF_CALL, meetingRegisteryPdf),
  ]);
}